import { Button, IconButton, Stack } from '@mui/material';
import { useState } from 'react';
import { BiEdit, BiLoader } from 'react-icons/bi';
import { useLunchFeedbackModule } from 'redux/reducers/user/dashboard/tms-feedback';
import LunchFeedbackModal from './LunchFeedbackModal';

const LunchFeedback = () => {
  const { data: lunchFeedbackData, isLoading } = useLunchFeedbackModule();

  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);

  const [routine, setRoutine] = useState({
    id: 0,
    date: ''
  });

  const handleOpenFeedbackModal = () => {
    setOpenFeedbackModal(true);
  };

  const handleCloseFeedbackModal = () => {
    setOpenFeedbackModal(false);
  };

  return (
    <>
      <LunchFeedbackModal
        openFeedbackModal={openFeedbackModal}
        handleCloseFeedbackModal={handleCloseFeedbackModal}
        routine={routine}
      />
      <div>
        {lunchFeedbackData ? (
          lunchFeedbackData.map((item, index) => {
            return (
              <>
                <Stack
                  direction={'row'}
                  justifyContent={'space-between'}
                  alignItems={'center'}
                  sx={{
                    backgroundColor: `${index % 2 === 0 ? '#edeff0' : 'white'}`,
                    p: 1.5
                  }}>
                  {item.routine_date}
                  {item?.feedback_submit_status == false ? (
                    <IconButton color="primary" aria-label="add to shopping cart">
                      <BiEdit
                        onClick={() => {
                          setRoutine({
                            date: item.routine_date,
                            id: item.routine
                          });
                          handleOpenFeedbackModal();
                        }}
                      />
                    </IconButton>
                  ) : (
                    <Button
                      style={{
                        background: '#006ECB',
                        color: '#fff',
                        fontSize: '12px',
                        height: '22px'
                      }}>
                      Already Submitted
                    </Button>
                  )}
                </Stack>
              </>
            );
          })
        ) : isLoading ? (
          <BiLoader />
        ) : (
          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
            <h4>No Data</h4>
          </Stack>
        )}
      </div>
    </>
  );
};

export default LunchFeedback;
